import { ref } from 'vue';
import useAlerts from './useAlerts';
import useGlobalUrl from './useGlobalUrl';
import useCompaniesQuery from './useCompaniesQuery';
import useContactsQuery from './useContactsQuery';

export default function useMergeDuplicates() {
  const { addAlert } = useAlerts();
  const { duplicatesMergeUrl } = useGlobalUrl();
  const { refetchCompanies } = useCompaniesQuery;
  const { refetchContacts } = useContactsQuery;
  const isMerging = ref(false);

  const mergeDuplicates = async ({ fieldsToMerge, primaryId, duplicateId, type }) => {
    isMerging.value = true;

    try {
      const response = await fetch(duplicatesMergeUrl, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          fieldsToMerge,
          primaryId,
          duplicateId,
          type,
        }),
      });

      if (!response.ok) {
        throw new Error('Failed to merge duplicates');
      }

      refetchCompanies.value();
      refetchContacts.value();
      isMerging.value = false;
      addAlert('Duplicates merged successfully', 'low', 4);
      return true;
    } catch (error) {
      console.error('Error merging duplicates:', error);
      addAlert('Failed to merge duplicates', 'high', 5);
      isMerging.value = false;
      return false;
    }
  };

  return {
    isMerging,
    mergeDuplicates,
  };
}
